// The two SME brands, captured verbatim from rensure-sme-smp/lib/domain/brands.ts.
// Only these two exist — everything a template needs to look/sound like a brand
// (name, colours, logo, call number) comes from here.

const ASSET_BASE = (
  process.env.APP_URL ?? "https://imsure-sme-poc-be044588064d.herokuapp.com"
).replace(/\/+$/, "");

export type BrandKey = "BUSINESS_COMPARE_DIRECT" | "MIND_YOUR_BUSINESS";

export type BrandConfig = {
  key: BrandKey;
  name: string;
  shortName: string;
  fromEmail: string;
  callNumber: string;
  portalDomain: string;
  /** Solid brand colour — text accents + email-client fallback. */
  primary: string;
  /** Header / payment-card fill (may be a gradient). */
  accentBg: string;
  /** Absolute logo URL (PNG — email clients don't render SVG reliably). */
  logoUrl?: string;
  logoAlign?: "left" | "center";
};

export const BRANDS: Record<BrandKey, BrandConfig> = {
  BUSINESS_COMPARE_DIRECT: {
    key: "BUSINESS_COMPARE_DIRECT",
    name: "BusinessCompare Direct",
    shortName: "BusinessCompare",
    fromEmail: "renewals@businesscomparedirect.co.uk",
    callNumber: "0333 202 6242",
    portalDomain: "myportal.co.uk",
    primary: "#3b54ff",
    accentBg: "#3b54ff",
    logoUrl: `${ASSET_BASE}/logos/business-compare-white.png`,
    logoAlign: "center",
  },
  MIND_YOUR_BUSINESS: {
    key: "MIND_YOUR_BUSINESS",
    name: "MindYourBusiness",
    shortName: "MindYourBusiness",
    fromEmail: "renewals@mindyourbusiness.co.uk",
    callNumber: "0333 202 6242",
    portalDomain: "myportal.co.uk",
    primary: "#8b5cf6",
    accentBg: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 48%, #ec4899 100%)",
    logoUrl: `${ASSET_BASE}/logos/myb-white.png`,
    logoAlign: "left",
  },
};

export const getBrand = (key: BrandKey): BrandConfig => BRANDS[key];
